/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Paper, IconButton, TablePagination } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

function VeiculoList({ refresh, onEdit, onVeiculoDeleted, placaFilter, proprietarioIdFilter }) {
  const { user } = useAuth();
  const [veiculos, setVeiculos] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const fetchVeiculos = () => {
    let query = `/veiculos?page=${page}&limit=${rowsPerPage}`;
    if (placaFilter) query += `&placa=${placaFilter}`;
    if (proprietarioIdFilter) query += `&proprietarioId=${proprietarioIdFilter}`;

    api.get(query)
      .then((response) => {
        setVeiculos(response.data.data);
        setTotalCount(response.data.totalCount);
      })
      .catch((error) => {
        console.error('Erro ao buscar ve\u00EDculos:', error);
      });
  };

  useEffect(() => {
    fetchVeiculos();
  }, [refresh, page, rowsPerPage, placaFilter, proprietarioIdFilter]);

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja deletar este ve\u00EDculo?')) return;
    try {
      await api.delete(`/veiculos/${id}`);
      console.log('Ve\u00EDculo deletado com sucesso!');
      onVeiculoDeleted();
      fetchVeiculos();
    } catch (error) {
      console.error('Erro ao deletar ve\u00EDculo:', error);
    }
  };

  return (
    <Paper>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="veiculos table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              {user?.tipo_usuario === 'admin' && <TableCell>Empresa ID</TableCell>}
              <TableCell>Propriet&aacute;rio</TableCell>
              <TableCell>Placa</TableCell>
              <TableCell>Marca</TableCell>
              <TableCell>Modelo</TableCell>
              <TableCell>Cor</TableCell>
              <TableCell>Ano</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {veiculos.map((veiculo) => (
              <TableRow key={veiculo.id} hover>
                <TableCell>{veiculo.id}</TableCell>
                {user?.tipo_usuario === 'admin' && <TableCell>{veiculo.empresa_id}</TableCell>}
                <TableCell>{veiculo.pessoa_nome || 'N/A'}</TableCell>
                <TableCell>{veiculo.placa}</TableCell>
                <TableCell>{veiculo.marca || 'N/A'}</TableCell>
                <TableCell>{veiculo.modelo || 'N/A'}</TableCell>
                <TableCell>{veiculo.cor || 'N/A'}</TableCell>
                <TableCell>{veiculo.ano || 'N/A'}</TableCell>
                <TableCell>
                  <IconButton aria-label="edit" onClick={() => onEdit(veiculo)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton aria-label="delete" onClick={() => handleDelete(veiculo.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        labelRowsPerPage="Linhas por p\u00E1gina:"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Paper>
  );
}

export default VeiculoList;
